import { Dispatch, SetStateAction } from 'react';

import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';

const CancelablePopup = ({
  isOpened,
  setIsOpened,
  onConfirm,
  title,
  text,
  cancelText = 'Cancel',
  confirmText = 'Confirm'
}: {
  isOpened: boolean;
  setIsOpened: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
  title: string;
  text: string;
  cancelText?: string;
  confirmText?: string;
}) => {
  return (
    <Dialog
      open={isOpened}
      slotProps={{
        paper: {
          sx: {
            maxWidth: '100%',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'flex-start',
            p: 3,
            backgroundColor: 'background.default',
            position: 'relative',
            overflow: 'visible'
          }
        }
      }}
      sx={{ zIndex: 3010 }}
      onClose={() => {
        setIsOpened(false);
      }}
    >
      <DialogContent
        sx={{
          maxWidth: 590,
          height: 121,
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box>
          <Typography
            sx={{
              mb: 1.5
            }}
          >
            {title}
          </Typography>
          <Typography>{text}</Typography>
        </Box>

        <Box
          sx={{
            justifyContent: 'flex-end',
            display: 'flex',
            width: 590,
            gap: '8px'
          }}
        >
          <Button
            fullWidth
            color='primary'
            sx={{ width: 120 }}
            variant='outlined'
            onClick={() => {
              setIsOpened(false);
            }}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 500, whiteSpace: 'nowrap' }}>
              {cancelText}
            </Typography>
          </Button>
          <Button
            fullWidth
            color='primary'
            sx={{ width: 120 }}
            variant='contained'
            onClick={() => {
              onConfirm();
              setIsOpened(false);
            }}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 500, whiteSpace: 'nowrap' }}>
              {confirmText}
            </Typography>
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelablePopup;
